export default __webpack_public_path__ + "static/media/Google.786897cc.png";